/**
 * 言語設定の状態
 */
const state = {
  // 言語設定
  value: null,
};

export { state as default };
